module.exports = __webpack_public_path__ + "static/media/material_bg.c24e8f80.png";